import { createIconComponent } from './createIconComponent';
import { ReactComponent as Icon } from './resources/video.svg';

export const IconVideo = createIconComponent(Icon);
